import { Link } from 'react-router-dom'
import styled from 'styled-components'
import BrwnieLogo from './BrwnieLogo'
import { FOOTER_APPLY, renewalPath } from './paths'
import { SERVICES } from './nav'

type RenewalFooterProps = {
  hideBar?: boolean
}

const CREW_URL = 'https://higherx.notion.site/b9ccb239d9784e7692cf596c466ef795?source=copy_link'
const PRIVACY_URL = 'https://higherx.notion.site/2021-06-10-0d9e5fc809104aef97a8679bf21510f8?pvs=143'
const TERMS_URL = 'https://higherx.notion.site/2021-06-10-42f4b3c848ee4182978736e1aace21fd'
const BIZ_URL = 'https://www.ftc.go.kr/info/bizinfo/communicationViewPopup.jsp?wrkr_no=7048801152'

export default function RenewalFooter({ hideBar = false }: RenewalFooterProps) {
  return (
    <Footer>
      <Inner>
        <Top>
          <Brand>
            <BrwnieLogo tone="white" height={26} />
            <Lead>브라우니는 (주)하이어엑스가 운영하는 무인매장 관리 서비스예요.</Lead>
            <Mail>제휴·제안 partnership@higherx.co.kr</Mail>
            <Social>
              <SocialLink href="https://pf.kakao.com/_aDlss/chat" target="_blank" rel="noopener noreferrer" aria-label="카카오톡 채널 (새 창)">
                <svg width="30" height="28" viewBox="0 0 30 28" aria-hidden="true">
                  <path fill="currentColor" d="M15 2C7.8 2 2 6.5 2 12c0 3.5 2.4 6.6 6 8.4l-1.4 5c-.1.4.3.7.6.5l5.9-3.9c.6.1 1.3.1 1.9.1 7.2 0 13-4.5 13-10S22.2 2 15 2z" />
                  <text x="15" y="15.2" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="7.6" fontWeight="900" fill="#0C2049">
                    TALK
                  </text>
                </svg>
              </SocialLink>
              <SocialLink href="https://blog.naver.com/higherx" target="_blank" rel="noopener noreferrer" aria-label="네이버 블로그 (새 창)">
                <svg width="30" height="28" viewBox="0 0 30 28" aria-hidden="true">
                  <path fill="currentColor" d="M6 3h18a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4h-6l-3 4-3-4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z" />
                  <text x="15" y="15" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="8.4" fontWeight="900" fill="#0C2049">
                    blog
                  </text>
                </svg>
              </SocialLink>
              <SocialLink href="https://www.facebook.com/brwniebrwnie/" target="_blank" rel="noopener noreferrer" aria-label="페이스북 (새 창)">
                <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="currentColor" />
                  <path fill="#0C2049" d="M13.2 19.5v-6.3h2.1l.3-2.5h-2.4V9.2c0-.7.2-1.2 1.2-1.2h1.3V5.8c-.2 0-1-.1-1.9-.1-1.9 0-3.2 1.2-3.2 3.3v1.8H8.5v2.5h2.1v6.3z" />
                </svg>
              </SocialLink>
              <SocialLink href="https://www.instagram.com/brwniebrwnie/" target="_blank" rel="noopener noreferrer" aria-label="인스타그램 (새 창)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
                  <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
                  <circle cx="12" cy="12" r="4.3" />
                  <circle cx="17.6" cy="6.4" r="1.2" fill="currentColor" stroke="none" />
                </svg>
              </SocialLink>
              <SocialLink href="https://www.youtube.com/@-brwnie-kv3hn" target="_blank" rel="noopener noreferrer" aria-label="유튜브 (새 창)">
                <svg width="30" height="22" viewBox="0 0 30 22" aria-hidden="true">
                  <rect x="1" y="1" width="28" height="20" rx="6" fill="currentColor" />
                  <path fill="#0C2049" d="M12 6.2v9.6l8-4.8z" />
                </svg>
              </SocialLink>
            </Social>
          </Brand>
          <Columns>
            <Column>
              <ColumnTitle>서비스</ColumnTitle>
              <FooterLink to={`${renewalPath('/')}#scope`}>서비스 소개</FooterLink>
              <FooterLink to={renewalPath('/industries')}>업종별 관리</FooterLink>
              <FooterLink to={renewalPath('/business')}>프랜차이즈 본사</FooterLink>
              <FooterLink to={renewalPath('/cases')}>관리 사례</FooterLink>
              <FooterLink to={renewalPath('/pricing')}>이용요금</FooterLink>
              <FooterLink to={renewalPath('/faq')}>FAQ</FooterLink>
            </Column>
            <Column>
              <ColumnTitle>함께하는 서비스</ColumnTitle>
              {SERVICES.map((item) => (
                <FooterLink key={item.key} to={item.path}>
                  {item.name}
                </FooterLink>
              ))}
            </Column>
            <Column>
              <ColumnTitle>브라우니</ColumnTitle>
              <FooterLink to={renewalPath('/story')}>브라우니 이야기</FooterLink>
              <FooterLink to={renewalPath('/press')}>브라우니 소식</FooterLink>
              <External href={CREW_URL} target="_blank" rel="noopener noreferrer">
                크루 모집
              </External>
              <FooterLink to={renewalPath('/map')}>전국 무인매장 지도</FooterLink>
              <FooterLink to={renewalPath('/shop')}>소모품 구매</FooterLink>
            </Column>
          </Columns>
        </Top>
        <Legal>
          <Company>
            (주)하이어엑스 · 대표이사 권민재 · 사업자등록번호 704-88-01152 · 통신판매업 2025-서울영등포-1305{' '}
            <Biz href={BIZ_URL} target="_blank" rel="noopener noreferrer">
              사업자정보확인
            </Biz>
            <br />
            서울시 영등포구 의사당대로 83, 위워크 여의도점 4층 · (주)하이어엑스
          </Company>
          <LegalLinks>
            <Privacy href={PRIVACY_URL} target="_blank" rel="noopener" aria-label="개인정보처리방침 (새 창)">
              개인정보처리방침
            </Privacy>
            <Terms href={TERMS_URL} target="_blank" rel="noopener" aria-label="서비스 이용약관 (새 창)">
              서비스 이용약관
            </Terms>
          </LegalLinks>
        </Legal>
      </Inner>
      {!hideBar && (
        <>
          <BarSpace />
          <BottomBar>
            <Consult to={renewalPath('/apply')}>1:1 상담하기</Consult>
            <Apply to={FOOTER_APPLY}>관리 신청하기</Apply>
          </BottomBar>
        </>
      )}
    </Footer>
  )
}

const FACE = `Pretendard, 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif`

const Footer = styled.footer`
  background: #0c2049;
  color: rgba(255, 255, 255, 0.8);
  font-family: ${FACE};
  font-size: 15px;
  line-height: 1.7;
  word-break: keep-all;
`

const Inner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: clamp(56px, 6vw, 80px) clamp(20px, 3.4vw, 40px) 40px;
`

const Top = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px 64px;
`

const Brand = styled.div`
  flex: 1 1 320px;
  max-width: 440px;

  > svg {
    height: 26px;
    width: auto;
    display: block;
  }
`

const Lead = styled.p`
  margin: 20px 0 0;
  font-family: ${FACE};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  color: #ffffff;
`

const Mail = styled.p`
  margin: 16px 0 0;
  font-family: ${FACE};
  font-size: 15px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.8);
`

const Social = styled.div`
  margin: 12px 0 0 -7px;
  display: flex;
  align-items: center;
  gap: 4px;
`

const SocialLink = styled.a`
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  color: #ffffff;
  opacity: 0.85;

  &:hover {
    opacity: 1;
  }
`

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px clamp(32px, 5vw, 72px);
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;
`

const ColumnTitle = styled.p`
  margin: 0 0 8px;
  font-family: ${FACE};
  font-size: 14px;
  font-weight: 700;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.62);
`

const FooterLink = styled(Link)`
  && {
    display: flex;
    align-items: center;
    min-height: 40px;
    color: #ffffff;
    text-decoration: none;
    font-family: ${FACE};
    font-size: 15px;
    font-weight: 600;
    line-height: 1.7;
  }
`

const External = styled.a`
  && {
    display: flex;
    align-items: center;
    min-height: 40px;
    color: #ffffff;
    text-decoration: none;
    font-family: ${FACE};
    font-size: 15px;
    font-weight: 600;
    line-height: 1.7;
  }
`

const Legal = styled.div`
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px 32px;
  font-family: ${FACE};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
`

const Company = styled.p`
  margin: 0;
  flex: 1 1 520px;
  font-family: ${FACE};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
`

const Biz = styled.a`
  && {
    display: inline-block;
    padding: 12px 4px;
    margin: -12px 0;
    color: #ffffff;
    font-family: ${FACE};
    font-size: 14px;
    font-weight: 600;
    line-height: 1.7;
    text-decoration: underline;
  }
`

const LegalLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
  margin-right: 60px;
`

const Privacy = styled.a`
  && {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    color: #ffffff;
    text-decoration: none;
    font-family: ${FACE};
    font-size: 14px;
    font-weight: 700;
    line-height: 1.7;
  }
`

const Terms = styled.a`
  && {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: ${FACE};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.7;
  }
`

const BarSpace = styled.div`
  display: none;
  height: 76px;

  @media (max-width: 860px) {
    display: block;
  }
`

const BottomBar = styled.div`
  display: none;

  @media (max-width: 860px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;
    display: flex;
    gap: 8px;
    padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
    background: rgba(255, 255, 255, 0.97);
    border-top: 1px solid #e5e8eb;
    box-shadow: 0 -12px 32px -20px rgba(12, 32, 73, 0.35);
  }
`

const Consult = styled(Link)`
  && {
    flex: 1 1 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    border-radius: 14px;
    background: #ffffff;
    border: 1.4px solid #d1d6db;
    color: #191f28;
    text-decoration: none;
    font-family: ${FACE};
    font-size: 16px;
    font-weight: 700;
    line-height: 1.7;
  }
`

const Apply = styled(Link)`
  && {
    flex: 1.7 1 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    border-radius: 14px;
    background: #003399;
    color: #ffffff;
    text-decoration: none;
    font-family: ${FACE};
    font-size: 16px;
    font-weight: 700;
    line-height: 1.7;
  }
`
